import React from "react"

const LegalNavItem = ({
  path,
  history,
  prefix = "",
  name = "",
  className = "",
}: {
  prefix: string
  path: string
  history: object
  name?: string
  className?: string
}): JSX.Element => {
  const itemId = prefix + path.split(" ").join("-").toLowerCase()
  const selected = window.location.pathname.startsWith(itemId)

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions
    <li
      key={path}
      className={`
      ${className || "legal-sidenav-list-item"} 
      legal-sidenav-list-item--${selected ? "selected" : "not-selected"}
    `}
      data-testid="legal-navigation-item"
    >
      <div
        onClick={(e) => {
          e.stopPropagation()
          history.push(itemId)
        }}
        className={`legal-sidenav-option legal-sidenav-option--${
          selected ? "colorA" : "colorB"
        } focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring`}
        role="button"
        onKeyDown={(event) => {
          event.stopPropagation()
          if (event.key === "Enter" || event.key === " ") {
            event.preventDefault()
            history.push(itemId)
          }
        }}
        tabIndex={0}
        data-testid="legal-navigation-item-button"
      >
        {name || path.split("/").pop()}
      </div>
    </li>
  )
}

LegalNavItem.defaultProps = {
  name: "",
  className: "",
}

export default LegalNavItem
